
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-today-dt',
    templateUrl: './today-dt.component.html',
    styleUrls: ['./today-dt.component.scss', '../../../dashboard.scss'],
    standalone: false
})
export class TodayDtComponent {
    @Input() dashboardData: any;
    totalSalesToday: any;
    totalOrdersItems: string = '';
    salesValuePerItem: string = '0';
    averageOrderValue: string = '0';
    sushiSalesToday: any = 0;
    sushiItemsSoldToday: any = 0;
    bentoSalesToday: any = 0;
    bentoItemsSoldToday: any = 0;
    commonSalesToday: any = 0;
    commonItemsSoldToday: any = 0;

    ngOnChanges(changes: SimpleChanges) {
        if (changes['dashboardData']) {
            // -------Today Section-------
            const dashBoardData = this.dashboardData?.dt_dashboard_data;
            this.totalSalesToday = this.setDecimalPoints(this.fnCheckNull(dashBoardData?.sales_today));

            // TOTAL ORDERS / ITEMS
            let todayItemsSold = this.fnCheckNull(dashBoardData?.today_items_sold);
            todayItemsSold = this.setDecimalPoints(todayItemsSold, 0);

            let todayNoOfCustOrders = this.fnCheckNull(dashBoardData?.today_no_of_cust_orders);
            todayNoOfCustOrders = this.setDecimalPoints(todayNoOfCustOrders, 0);

            this.totalOrdersItems = `${this.formatNumber(todayNoOfCustOrders)} / ${this.formatNumber(todayItemsSold)}`;

            // SALES VALUE / ITEM
            if (todayItemsSold > 0) {
                let todaySalesValueByItem = this.totalSalesToday / todayItemsSold;
                todaySalesValueByItem = this.setDecimalPoints(todaySalesValueByItem, 2);
                this.salesValuePerItem = todaySalesValueByItem.toFixed(2);
            } else {
                this.salesValuePerItem = '0';
            }

            // AVERAGE ORDER $
            if (todayNoOfCustOrders > 0) {
                let todayAverageOrder = this.totalSalesToday / todayNoOfCustOrders;
                todayAverageOrder = this.setDecimalPoints(todayAverageOrder, 2);
                this.averageOrderValue = todayAverageOrder.toFixed(2);
            } else {
                this.averageOrderValue = '0';
            }

            // SUSHI SALES
            let todaySushiSales = this.fnCheckNull(dashBoardData?.today_dt_sushi_sales);
            todaySushiSales = this.setDecimalPoints(todaySushiSales);
            this.sushiSalesToday = todaySushiSales;

            // SUSHI ITEM SOLD
            let todaySushiItemsSold = this.fnCheckNull(dashBoardData?.today_dt_sushi_items_sold);
            todaySushiItemsSold = this.setDecimalPoints(todaySushiItemsSold, 0);
            this.sushiItemsSoldToday = todaySushiItemsSold;

            // BENTO SALES
            let todayBentoSales = this.fnCheckNull(dashBoardData?.today_dt_bento_sales);
            todayBentoSales = this.setDecimalPoints(todayBentoSales);
            this.bentoSalesToday = todayBentoSales;

            // BENTO ITEM SOLD
            let todayBentoItemsSold = this.fnCheckNull(dashBoardData?.today_dt_bento_items_sold);
            todayBentoItemsSold = this.setDecimalPoints(todayBentoItemsSold, 0);
            this.bentoItemsSoldToday = todayBentoItemsSold;

            // COMMON SALES
            let todayCommonSales = this.fnCheckNull(dashBoardData?.today_dt_common_sales);
            todayCommonSales = this.setDecimalPoints(todayCommonSales);
            this.commonSalesToday = todayCommonSales;

            // COMMON ITEM SOLD
            let todayCommonItemsSold = this.fnCheckNull(dashBoardData?.today_dt_common_items_sold);
            todayCommonItemsSold = this.setDecimalPoints(todayCommonItemsSold, 0);
            this.commonItemsSoldToday = todayCommonItemsSold;
        }
    }

    ngOnInit() { }

    setDecimalPoints(value: number, decimal: number = 1): number {
        return Number(Number(value).toFixed(decimal));
    }
    fnCheckNull(a: any): number {
        return a == null ? 0 : a;
    }
    formatNumber(value: number): string {
        return value.toLocaleString('en-US', { maximumFractionDigits: 0 });
    }
}
